window.addEventListener("load", () => {
  console.log("Nosto Page Script Loaded");
  
  /* -------------------------------
   * Helpers
   * ----------------------------- */
  function updateColorVariantCount(el) {
    if (el.dataset.countUpdated) return;
    el.dataset.countUpdated = "true";
    const values = (el.textContent || "").split("|");
    if (values.length > 1) {
      el.textContent = `Colors +${values.length - 1}`;
      el.style.opacity = 1;
    } else {
      el.textContent = "";
    }
  }

  function wrapDivsWithAnchor() {
    document.querySelectorAll(".nosto-image-container").forEach(container => {
      if (container.closest("a")) return;
      const url = container.getAttribute("product-url");
      if (url) {
        const a = document.createElement("a");
        a.href = url;
        container.parentNode.insertBefore(a, container);
        a.appendChild(container);
      }
    });
  }

  /* -------------------------------
   * Flickity
   * ----------------------------- */
  function initSlider(slider, opts = {}) {
    if (!slider || Flickity.data(slider)) return;

    function tryInit(attempts = 0) {
      const items = slider.querySelectorAll(".nosto-list-item");
      const hasItems = items.length > 0;
      const hasHeight = slider.offsetHeight > 0 || (items[0] && items[0].offsetHeight > 0);

      if (hasItems && hasHeight) {
        const tallest = Math.max(...Array.from(items).map(i => i.offsetHeight));
        slider.style.minHeight = (tallest / 2) + "px";

        const flkty = new Flickity(slider, Object.assign({
          cellAlign: "left",
          contain: true,
          prevNextButtons: true,
          pageDots: false
        }, opts));

        requestAnimationFrame(() => {
          flkty.resize();
          flkty.reposition();
          slider.style.visibility = "visible";

          setTimeout(() => {
            flkty.resize();
            flkty.reposition();
            slider.style.visibility = "visible";
          }, 50);
        });

        console.log("✅ Init slider:", slider.className);
      } else if (attempts < 50) {
        setTimeout(() => tryInit(attempts + 1), 100);
      } else {
        console.warn("⚠️ Slider never became visible:", slider.className);
      }
    }

    tryInit();
  }

  /* -------------------------------
   * Wishlist
   * ----------------------------- */
  function handleWishListClick(evt) {
    evt.preventDefault();
    const btn = evt.currentTarget;
    const product = btn.closest(".nosto-list-item");
    if (!product) return;

    const obj = {
      epi: product.dataset.variantId,
      du: product.dataset.productUrl,
      empi: product.dataset.productId,
      iu: product.dataset.productImageUrl
    };

    const isSaved = btn.classList.toggle("is-saved");
    window._swat[isSaved ? "addToWishList" : "removeFromWishList"](obj, () => {
      theme.updateWishList();
    });
  }

  function initWishlistButtons(scope = document) {
    scope.querySelectorAll(".wishlist").forEach(btn => {
      if (btn.dataset.wishlistInit) return;
      const { empi, epi } = btn.dataset;
      if (window.myWishList) {
        const match = window.myWishList.find(i => i.empi == empi || i.epi == epi);
        if (match) btn.classList.add("is-saved");
      }
      btn.addEventListener("click", handleWishListClick);
      btn.dataset.wishlistInit = "true";
    });
  }

  /* -------------------------------
   * Add to Cart
   * ----------------------------- */


  /* -------------------------------
   * Initialize All Sliders on Page
   * ----------------------------- */
  function initAllSliders() {
    document.querySelectorAll(".nosto-list").forEach(slider => {
      initSlider(slider);
      slider.querySelectorAll(".colorVariantCount").forEach(updateColorVariantCount);
      initWishlistButtons(slider);
      // initCartATC(slider);
    });
  }

  /* -------------------------------
   * Observer for Dynamically Added Content
   * ----------------------------- */
  const nostoObserver = new MutationObserver(muts => {
    muts.forEach(m => {
      m.addedNodes.forEach(node => {
        if (!(node instanceof HTMLElement)) return;
        if (node.matches(".nosto-list")) {
          initSlider(node);
          node.querySelectorAll(".colorVariantCount").forEach(updateColorVariantCount);
          initWishlistButtons(node);
          initCartATC(node);
        } else {
          node.querySelectorAll(".nosto-list").forEach(slider => {
            initSlider(slider);
            slider.querySelectorAll(".colorVariantCount").forEach(updateColorVariantCount);
            initWishlistButtons(slider);
            // initCartATC(slider);
          });
        }
      });
    });
  });
  nostoObserver.observe(document.body, { childList: true, subtree: true });

  /* -------------------------------
   * Init on Load
   * ----------------------------- */
  wrapDivsWithAnchor();
  initAllSliders();
  initWishlistButtons();
});